import React from "react";
import Header from "./navigation/Header";
import Footer from "./navigation/Footer";
import useLayoutAuth from "@/hooks/useLayoutAuth";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { OrganizationSchema } from "@/components/seo/schemas";
import BackToTop from "@/components/BackToTop";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, loading, isAuthEnabled, handleSignOut, error } = useLayoutAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-primary focus:text-primary-foreground">
        Skip to main content
      </a>
      <OrganizationSchema />
      <Header 
        user={user}
        isAuthEnabled={isAuthEnabled}
        handleSignOut={handleSignOut}
      />
      <main id="main-content" className="flex-grow">
        {error && (
          <Alert variant="destructive" className="m-4">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Authentication Error</AlertTitle>
            <AlertDescription>
              There was a problem with the authentication service. The application will continue to function with limited capabilities.
              {process.env.NODE_ENV === 'development' && (
                <div className="mt-2 text-xs opacity-80">{error.message}</div>
              )}
            </AlertDescription>
          </Alert>
        )}
        {children}
      </main>
      <Footer user={user} />
      <BackToTop />
    </div>
  );
};

export default Layout;
